// Types
import { BCGraph } from "services";
import { TBCSectionData } from "..";

/**
 * Transform INDIVIDUALS data to be used by LD12Chart
 *
 * @param {BCGraph} data
 * @returns {{ labels: any; values: any; }}
 */
export const convertIndividualsData = (data: BCGraph): TBCSectionData[] | undefined => {
    if (!data.data_series?.score_y || !data.data_series?.scores) return;

    const ScoresArr = Object.entries(data.data_series.scores);

    const individuals = data.data_series?.score_y.map((label, i) => {
        // This will generate [["0", 6], ["1", 3], ["2", 2]]
        const values = ScoresArr.map((score) => [score[0], score[1][i]]);

        // Convert to object {"0": 6, "1": 3, "2": 2}
        const series: Record<string, number | null> = Object.fromEntries(values);

        return {
            id: label["user.id"],
            label: label["user.name"],
            company_name: "",
            entity_type: "person",
            entity_id: label["assessment.id"],
            entity_name: label["user.name"],
            has_real_pace: true,
            show_real_pace: true,
            series,
            enabled: true,
        };
    });

    return individuals;
};
